import { uuidv4 } from "../../utils/filters";

import * as actionTypes from "./actionTypes";
import { setExceptionReporting, unsetExceptionReporting } from "./exceptionReporting";

export const toastMessageTypes = {
  error: "error",
  error_v2: "error_v2",
  success: "success",
  success_v2: "success_v2",
  warning: "warning",
};

export const addToast =
  ({
    dismissMessage,
    dismissTimeout,
    hideDismissButton,
    hideReportButton,
    message,
    messageType,
    requestId,
  }) =>
  (dispatch) => {
    const toastId = uuidv4();
    const showExceptionReporting = () => {
      dispatch(
        setExceptionReporting({
          dismiss: () => {
            dispatch(unsetExceptionReporting());
          },
          requestId,
        }),
      );
    };

    dispatch({
      payload: {
        dismissMessage,
        dismissTimeout,
        hideDismissButton,
        hideReportButton,
        message,
        messageType,
        onReportButtonClick: showExceptionReporting,
        requestId,
        toastId,
      },
      type: actionTypes.ADD_TOAST,
    });
  };

export const removeToast = ({ toastId }) => ({
  payload: {
    toastId,
  },
  type: actionTypes.REMOVE_TOAST,
});

const clearAllToasts = () => ({
  type: actionTypes.CLEAR_ALL_TOASTS,
});
